/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import { webViewTapped } from '../../../actions/tapEvents'

const moreSicdInfoTapped = async (t, regionalContentLookup) => {
  const eventID = 'LearnMoreAboutSicd'
  const lookupValue = regionalContentLookup('remoteMonitoringTerm')
  const url = lookupValue.startsWith('http') ? lookupValue : t(lookupValue) // assume any value starting with http is link otherwise it needs translation
  webViewTapped(url, eventID)
}

const getDefaultContent = (t) => (
  <View testID="default-content">
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringDefaultParagraph1')}</Text>
    <Text style={[textStyles.h3, styles.shark_grey]}>{t('thingsToKnow')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringDefaultParagraph2')}</Text>
  </View>
)

const sicdContent = (regionalContentLookup, t) => (
  <View testID="more-sicd-info-content">
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDParagraph1')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDParagraph2')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDParagraph3')}</Text>
    <Text style={[textStyles.h3, styles.shark_grey]}>{t('faq:thingsToKnow')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDWhenButtonFlash')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDPressButton')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDStayClose')}</Text>
    <Text style={textStyles.bodyContentText}>{t('remoteMonitoringSICDPressButtonAgain')}</Text>
    <TouchableOpacity
      onPress={() => { moreSicdInfoTapped(t, regionalContentLookup) }}
      accessible
      testID="learn-more-sicd"
    >
      <View style={styles.button}>
        <Text style={[styles.hyperlink, styles.textMargin, styles.linkText]}>
          {t('remoteMonitoringSICDLearnMore')}
        </Text>
      </View>
    </TouchableOpacity>
  </View>
)

const conditionalContent = (deviceModel, regionalContentLookup, t) => {
  if (deviceModel === 'S-ICD') {
    return sicdContent(regionalContentLookup, t)
  }

  return getDefaultContent(t)
}

function RemoteMonitoring({ deviceModel, regionalContentLookup }) {
  const { t } = useTranslation('faq')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="what-is-remote-mon-header">{t('whatIsRemoteMonitoring')}</Text>
      </View>
      {conditionalContent(deviceModel, regionalContentLookup, t)}
    </View>
  )
}

RemoteMonitoring.propTypes = {
  deviceModel: PropTypes.string,
  regionalContentLookup: PropTypes.func.isRequired,
}

RemoteMonitoring.defaultProps = {
  deviceModel: 'default',
}

export default RemoteMonitoring
